import React from "react";
import { motion } from "framer-motion";

const DriveStats = ({ usedMB = 0, totalGB = 0, percentage = 0 }) => {
  const displayUsed = usedMB > 1024 
    ? (usedMB / 1024).toFixed(2) + " GB" 
    : usedMB.toFixed(2) + " MB";

  return (
    <div className="bg-white/10 backdrop-blur-md p-5 rounded-3xl border border-white/10">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">
            Storage
          </h4>
          <p className="text-base font-black text-white flex items-baseline gap-1.5">
            {displayUsed} 
            <span className="text-slate-400 text-xs font-bold font-sans">of {totalGB} GB used</span>
          </p>
        </div>
        <span className="text-[11px] font-black text-indigo-400 bg-white/10 px-2.5 py-1.5 rounded-xl border border-white/5 shadow-inner">
          {percentage}%
        </span>
      </div>
      
      <div className="w-full bg-white/5 rounded-full h-2.5 p-0.5 border border-white/5">
        <motion.div 
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 1.5, ease: "circOut" }}
          className="bg-gradient-to-r from-indigo-500 to-indigo-400 h-full rounded-full shadow-[0_0_15px_rgba(99,102,241,0.5)]"
        />
      </div>
      
      <p className="text-[9px] text-slate-500 mt-4 leading-relaxed font-bold uppercase tracking-wider">
        Upgrade to premium for 100GB extra storage
      </p>
    </div>
  );
};

export default DriveStats;
